// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3uXFv","hiddenElements":"Header_hiddenElements__3Qaa3","search":"Header_search__3eOgU","dark":"Header_dark__2aunY","wrapper":"Header_wrapper__3xbWp"};